import { useEffect, useState } from "react";
import { DATA_CHANGED_EVENT, request } from "./api";
import type { AudienceCheck } from "../types";

// For each module: how many of its cohort's teachers are in no group, and which
// items are shown to chosen groups only. A failed lookup leaves a module with
// no warning rather than a broken page.
export function useAudienceChecks(moduleIDs: string[]): Record<string, AudienceCheck> {
  const [checks, setChecks] = useState<Record<string, AudienceCheck>>({});
  const [reload, setReload] = useState(0);
  const key = [...new Set(moduleIDs)].sort().join(",");

  useEffect(() => {
    const bump = () => setReload((count) => count + 1);
    window.addEventListener(DATA_CHANGED_EVENT, bump);
    return () => window.removeEventListener(DATA_CHANGED_EVENT, bump);
  }, []);

  useEffect(() => {
    if (!key) return;
    let cancelled = false;
    Promise.all(
      key.split(",").map((id) =>
        request<AudienceCheck>(`/api/admin/modules/${id}/audience-check`)
          .then((check) => [id, check] as const)
          .catch(() => null)
      )
    ).then((results) => {
      if (cancelled) return;
      setChecks(
        Object.fromEntries(results.filter((entry): entry is [string, AudienceCheck] => !!entry))
      );
    });
    return () => {
      cancelled = true;
    };
  }, [key, reload]);

  return checks;
}
